module.exports = __webpack_public_path__ + "img/backup.7833179a.png";